import clsx from 'clsx';

import styles from './Icons.module.css';
import { LoaderIconProps } from './types';

const LoaderIcon = ({ className, size = 'small' }: LoaderIconProps) => {
  return (
    <div
      className={clsx(
        styles.loaderIcon,
        {
          [styles.loaderIconMedium]: size === 'medium',
          [styles.loaderIconLarge]: size === 'large',
        },
        className,
      )}
    />
  );
};

export default LoaderIcon;
